import dayjs from 'dayjs'

export const MAINTENANCE_START_AT: string | null = null
export const MAINTENANCE_END_AT: string | null = null

export function isMaintenancePeriod(params: {
  currentAt?: string
  endAt: string | null
  skipFlag: string | null
  startAt: string | null
}): boolean {
  if (params.skipFlag === 'true' || params.startAt === null || params.endAt === null) {
    return false
  }
  const current = dayjs(params.currentAt)
  return current.isAfter(dayjs(params.startAt)) && current.isBefore(dayjs(params.endAt))
}
